import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55a8753c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-x2 mb-0" }, "Chỉnh sửa ảnh đại diện", -1))
const _hoisted_2 = { class: "avatar-crop" }
const _hoisted_3 = { class: "avatar-crop__main" }
const _hoisted_4 = { class: "avatar-crop__stage" }
const _hoisted_5 = {
  class: "avatar-crop__toolbar",
  role: "toolbar",
  "aria-label": "Công cụ chỉnh ảnh"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "avatar-crop__meta" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "avatar-crop__label" }, "Xem trước", -1))
const _hoisted_13 = { class: "avatar-crop__preview-wrap" }
const _hoisted_14 = {
  ref: "previewRef",
  class: "avatar-crop__preview"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "avatar-crop__hint" }, " Kéo để cắt khung hình. Dùng thanh công cụ để phóng to / xoay. ", -1))
const _hoisted_16 = { class: "avatar-crop__specs" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Định dạng: jpg, jpeg, png, gif, webp", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Tỷ lệ cắt: 1:1 (tròn)", -1))
const _hoisted_19 = { class: "d-flex justify-content-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
    width: "720px",
    "destroy-on-close": "",
    "append-to-body": "",
    "close-on-click-modal": false,
    onOpened: _ctx.onDialogOpened,
    onClosed: _ctx.onClosed
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.CANCEL,
          "color-type": _ctx.ButtonTypeColors.SECONDARY,
          disabled: _ctx.confirming,
          onClick: _ctx.close
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode("Hủy")
          ]),
          _: 1
        }, 8, ["button-type", "color-type", "disabled", "onClick"]),
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.SAVE,
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          disabled: _ctx.confirming || !_ctx.cropperReady,
          "is-loading": _ctx.confirming,
          onClick: _ctx.confirm
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode("Dùng ảnh này")
          ]),
          _: 1
        }, 8, ["button-type", "color-type", "disabled", "is-loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              ref: "imageRef",
              class: "avatar-crop__source",
              alt: "Ảnh đang chỉnh sửa",
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args)))
            }, null, 544)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "avatar-crop__tool",
              title: "Phóng to",
              disabled: !_ctx.cropperReady,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoom(0.1)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faSearchPlus }, null, 8, ["icon"])
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              type: "button",
              class: "avatar-crop__tool",
              title: "Thu nhỏ",
              disabled: !_ctx.cropperReady,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoom(-0.1)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faSearchMinus }, null, 8, ["icon"])
            ], 8, _hoisted_7),
            _createElementVNode("button", {
              type: "button",
              class: "avatar-crop__tool",
              title: "Xoay trái",
              disabled: !_ctx.cropperReady,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rotate(-90)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faRotateLeft }, null, 8, ["icon"])
            ], 8, _hoisted_8),
            _createElementVNode("button", {
              type: "button",
              class: "avatar-crop__tool",
              title: "Xoay phải",
              disabled: !_ctx.cropperReady,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rotate(90)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faRotateRight }, null, 8, ["icon"])
            ], 8, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "avatar-crop__tool",
              title: "Đặt lại",
              disabled: !_ctx.cropperReady,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faArrowsRotate }, null, 8, ["icon"])
            ], 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("aside", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, null, 512)
          ]),
          _hoisted_15,
          _createElementVNode("ul", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("li", null, "Dung lượng tối đa: " + _toDisplayString(_ctx.maxSizeMb) + "MB", 1),
            _hoisted_18
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened", "onClosed"]))
}